import type React from 'react'
import { Button, Link } from 'react-aria-components'

import { css } from '@portal/styled-system/css'
import type { SystemStyleObject } from '@portal/styled-system/types/system-types'

import { navbarItem } from '../styles/recipe'

interface NavbarItemProps {
    navbarItemType: 'link' | 'button'
    href?: string
    onClick?: () => void
    styles?: SystemStyleObject
}

export function NavbarItem({
    children,
    navbarItemType,
    href,
    onClick,
    styles,
}: React.PropsWithChildren<NavbarItemProps>) {
    const classes = navbarItem()

    if (navbarItemType === 'link') {
        return (
            <li className={css(styles)}>
                <Link className={classes.content} href={href} target="_blank" rel="noreferrer">
                    {children}
                </Link>
            </li>
        )
    }
    return (
        <li className={css(styles)}>
            <Button className={classes.content} onClick={onClick}>
                {children}
            </Button>
        </li>
    )
}
